"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equal = exports.elementaryStreamIterator = exports.streamReader = exports.packetStreamBitReader = exports.packetStreamGenerator = exports.packetGenerator = exports.BitReader = exports.parseSPS = exports.expGolobDec = exports.expGolombEnc = exports.strToUint8 = exports.bufferToStr = exports.s16 = exports.u16 = exports.u24 = exports.s32 = exports.u32 = exports.u64 = exports.concatenate = void 0;

var _types = _interopRequireDefault(require("../types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * concatenate - Concat an array of byte buffers
 *
 * @param  {type} resultConstructor Type you want to produce (eg: Uint8Array)
 * @param  {type} ...arrays         A spread of array byte buffers
 */
var concatenate = function concatenate(resultConstructor) {
  var totalLength = 0;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  for (var _i = 0; _i < arrays.length; _i++) {
    var arr = arrays[_i];
    totalLength += arr.length;
  }

  var result = new resultConstructor(totalLength);
  var offset = 0;

  for (var _i2 = 0; _i2 < arrays.length; _i2++) {
    var _arr = arrays[_i2];
    result.set(_arr, offset);
    offset += _arr.length;
  }

  return result;
};

exports.concatenate = concatenate;

var unsignedBytes = function unsignedBytes(input, dstConstructor) {
  var arr = new Uint8Array(dstConstructor.BYTES_PER_ELEMENT);

  for (var i = 0; i < arr.length; i++) {
    var byte = input & 0xff;
    arr[i] = byte;
    input = (input - byte) / 256;
  }

  return arr.reverse();
};
/**
 * Take a 64bit number and return an unsigned 8 bit array
 */


var u64 = function u64(input) {
  return unsignedBytes(input, {
    BYTES_PER_ELEMENT: 8
  });
};
/**
 * Take a 32bit number and return an unsigned 8 bit array
 */


exports.u64 = u64;

var u32 = function u32(input) {
  return unsignedBytes(input, Uint32Array);
};

exports.u32 = u32;

var s32 = function s32(input) {
  return unsignedBytes(input >> 0, Int32Array);
};

exports.s32 = s32;

var u24 = function u24(input) {
  return unsignedBytes(input, {
    BYTES_PER_ELEMENT: 3
  });
};
/**
 * Take a 16bit number and return an unsigned 8 bit array
 */


exports.u24 = u24;

var u16 = function u16(input) {
  return unsignedBytes(input, Uint16Array);
};

exports.u16 = u16;

var s16 = function s16(input) {
  return unsignedBytes(input >> 0, Int16Array);
};

exports.s16 = s16;

var bufferToStr = function bufferToStr(input) {
  return String.fromCharCode.apply(null, input);
};
/**
 * Convert a string to a Uint8Array
 */


exports.bufferToStr = bufferToStr;

var strToUint8 = function strToUint8(str) {
  var buf = new Uint8Array(str.length);

  for (var i = 0; i < str.length; i++) {
    buf[i] = str.charCodeAt(i) & 255;
  }

  return buf;
};

exports.strToUint8 = strToUint8;

var expGolombEnc = function expGolombEnc(input, signed) {
  var value = input;

  if (input < 0) {
    value = -(input * 2);
  }

  if (signed) {
    if (input < 0) {
      value = -(input * 2);
    } else {
      value = input * 2 - 1;
    }
  }

  var bin = (value + 1).toString(2);
  return '0'.repeat(bin.length - 1) + bin;
};

exports.expGolombEnc = expGolombEnc;

var expGolobDec = function expGolobDec(input) {
  if (input === '1') {
    return 0;
  }

  var value = parseInt(input, 2) - 1;
  return value;
};

exports.expGolobDec = expGolobDec;

var parseSPS = function parseSPS(input) {
  var reader = new BitReader(input);
  var sps = {};
  reader.readBits(8);
  sps.profileIDC = reader.readBits(8);
  sps.constraint_set0_flag = reader.readBit();
  sps.constraint_set1_flag = reader.readBit();
  sps.constraint_set2_flag = reader.readBit();
  sps.constraint_set3_flag = reader.readBit();
  sps.constraint_set4_flag = reader.readBit(); /// forbidden zero bits

  reader.readBits(3);
  sps.levelIDC = reader.readBits(8);
  sps.seq_param_set_id = reader.readExpGolomb();
  var extras = [100, 122, 244, 44, 83, 86, 118, 128];

  if (extras.includes(sps.profileIDC)) {
    sps.chroma_format_idc = reader.readExpGolomb();

    if (sps.chroma_format_idc === 3) {
      sps.separate_color_plane_flag = reader.readBit();
    }

    sps.bit_depth_luma_minus8 = reader.readExpGolomb();
    sps.bit_depth_chroma_minus8 = reader.readExpGolomb();
    reader.readBit(); // lossless_qpprime_y_zero_flag

    sps.seq_scaling_matrix_present_flag = reader.readBit();

    if (sps.seq_scaling_matrix_present_flag) {
      var scalingList = sps.chroma_format_idc != 3 ? 8 : 12;

      for (var i = 0; i < scalingList; i++) {
        if (reader.readBit()) {}
      }
    }
  }

  sps.log2_max_frame_num_minus4 = reader.readExpGolomb();
  sps.pic_order_cnt_type = reader.readExpGolomb();

  if (sps.pic_order_cnt_type === 0) {
    sps.log2_max_pic_order_cnt_lsb_minus4 = reader.readExpGolomb();
  }

  if (sps.pic_order_cnt_type === 1) {
    sps.delta_pic_order_always_zero_flag = reader.readBit();
    sps.offset_for_non_ref_pic = reader.readExpGolomb(); /// signed exp golomb

    sps.offset_for_top_to_bottom_field = reader.readExpGolomb(); /// signed exp golomb

    sps.num_ref_frames_in_pic_order_cnt_cycle = reader.readExpGolomb();

    for (var i = 0; i < sps.num_ref_frames_in_pic_order_cnt_cycle; i++) {
      reader.readExpGolomb(); // signed exp golomb
    }
  }

  sps.max_num_ref_frames = reader.readExpGolomb();
  sps.gaps_in_frame_num_value_allowed_flag = reader.readBit();
  sps.pic_width_in_mbs_minus1 = reader.readExpGolomb();
  sps.pic_height_in_map_units_minus1 = reader.readExpGolomb();
  sps.frame_mbs_only_flag = reader.readBit();

  if (sps.frame_mbs_only_flag === 0) {
    sps.mb_adaptive_frame_field_flag = reader.readBit();
  }

  sps.direct_8x8_inference_flag = reader.readBit();
  sps.frame_cropping_flag = reader.readBit();
  sps.frame_crop_top_offset = 0;
  sps.frame_crop_bottom_offset = 0;
  sps.frame_crop_left_offset = 0;
  sps.frame_crop_right_offset = 0;

  if (sps.frame_cropping_flag) {
    sps.frame_crop_left_offset = reader.readExpGolomb();
    sps.frame_crop_right_offset = reader.readExpGolomb();
    sps.frame_crop_top_offset = reader.readExpGolomb();
    sps.frame_crop_bottom_offset = reader.readExpGolomb();
  }

  sps.width = Math.ceil((sps.pic_width_in_mbs_minus1 + 1) * 16 - sps.frame_crop_left_offset * 2 - sps.frame_crop_right_offset * 2);
  sps.height = (2 - sps.frame_mbs_only_flag) * (sps.pic_height_in_map_units_minus1 + 1) * 16 - sps.frame_crop_top_offset * 2 - sps.frame_crop_bottom_offset * 2;
  var vui;
  sps.vui_parameters_present_flag = reader.readBit();

  if (sps.vui_parameters_present_flag) {
    vui = {};
    vui.aspect_ratio_info_present_flag = reader.readBit();

    if (vui.aspect_ratio_info_present_flag) {
      vui.aspect_ratio_idc = reader.readBits(8);

      if (vui.aspect_ratio_idc === 255) {
        vui.sar_width = reader.readBits(8);
        vui.sar_height = reader.readBits(8);
      }

      vui.overscan_info_present_flag = reader.readBit();

      if (vui.overscan_info_present_flag) {
        vui.overscan_appropriate_flag = reader.readBit();
      }

      vui.video_signal_type_present_flag = reader.readBit();

      if (vui.video_signal_type_present_flag) {
        vui.video_format = reader.readBits(3);
        vui.video_full_range_flag = reader.readBit();
        vui.color_description_present_flag = reader.readBit();

        if (vui.color_description_present_flag) {
          vui.color_primaries = reader.readBits(8);
          vui.transfer_characteristics = reader.readBits(8);
          vui.matrix_coefficients = reader.readBits(8);
        }
      }

      vui.chroma_location_info_present_flag = reader.readBit();

      if (vui.chroma_loc_info_present_flag) {
        vui.chroma_sample_loc_type_top_field = reader.readExpGolomb();
        vui.chroma_sample_loc_type_bottom_field = reader.readExpGolomb();
      }

      vui.timing_info_present_flag = reader.readBit();

      if (vui.timing_info_present_flag) {
        vui.num_units_in_tick = reader.readBits(32);
        vui.time_scale = reader.readBits(32);
        vui.fixed_frame_rate_flag = reader.readBit();
      }

      vui.nal_hrd_parameters_present_flag = reader.readBit();

      if (vui.nal_hrd_parameters_present_flag) {// FUCK
      }
    }

    sps.vui = vui;
  }

  return sps;
};

exports.parseSPS = parseSPS;

var BitReader =
/*#__PURE__*/
function () {
  function BitReader(input) {
    _classCallCheck(this, BitReader);

    this.data = input;
    this.length = input.byteLength;
    this.cb = 0;
  }

  _createClass(BitReader, [{
    key: "currentBit",
    value: function currentBit() {
      return this.cb;
    }
  }, {
    key: "readBit",
    value: function readBit() {
      var index = Math.floor(this.cb / 8);
      var offset = this.cb % 8 + 1;
      this.cb += 1;
      return this.data[index] >> 8 - offset & 0x01;
    }
  }, {
    key: "readBits",
    value: function readBits(n) {
      var result = 0;

      for (var i = 0; i < n; i++) {
        result |= this.readBit() << n - i - 1;
      }

      return result;
    }
  }, {
    key: "readExpGolomb",
    value: function readExpGolomb() {
      var result = 0;
      var i = 0;

      while (this.readBit() === 0 && i < 32) {
        i += 1;
      }

      result = this.readBits(i);
      result += (1 << i) - 1;
      return result;
    }
  }, {
    key: "rewind",
    value: function rewind(n) {
      this.cb -= n;
    }
  }, {
    key: "atEnd",
    value: function atEnd() {
      if (this.cb >= this.data.length * 8) {
        return true;
      }

      return false;
    }
  }]);

  return BitReader;
}();

exports.BitReader = BitReader;

var packetGenerator = function packetGenerator(packets) {
  var packetIdx = -1;
  return {
    next: function next() {
      return packets[packetIdx++];
    }
  };
};

exports.packetGenerator = packetGenerator;

var packetStreamGenerator = function packetStreamGenerator(packetGenerator) {
  var _currentPacket = packetGenerator.next();

  return {
    next: function next() {
      _currentPacket = packetGenerator.next();

      if (_currentPacket) {
        if (_currentPacket.constructor.name === _types.default.Array) {
          return new BitReader(new Uint8Array(_currentPacket));
        } else {
          var data = _currentPacket.data;

          if (_currentPacket.data.constructor.name != _types.default.Uint8Array) {
            data = new Uint8Array(data);
          }

          return new BitReader(data);
        }
      }
    },
    currentPacket: function currentPacket() {
      return _currentPacket;
    }
  };
};

exports.packetStreamGenerator = packetStreamGenerator;

var packetStreamBitReader = function packetStreamBitReader(packetStreamGenerator) {
  var reader = packetStreamGenerator.next();
  return {
    readBit: function readBit() {
      if (reader) {
        if (reader.currentBit() < reader.length * 8) {
          return reader.readBit();
        } else {
          reader = packetStreamGenerator.next();

          if (reader) {
            return reader.readBit();
          }
        }
      }
    },
    readBits: function readBits(n) {
      if (reader) {
        if (reader.currentBit() < reader.length * 8) {
          return reader.readBits(n);
        } else {
          reader = packetStreamGenerator.next();

          if (reader) {
            return reader.readBits(n);
          }
        }
      }
    },
    currentBit: function currentBit() {
      return reader.currentBit();
    },
    currentPacket: function currentPacket() {
      if (packetStreamGenerator) {
        return packetStreamGenerator.currentPacket();
      }
    },
    rewind: function rewind(n) {
      if (reader) {
        reader.cb -= n;
      }
    },
    atEnd: function atEnd() {
      if (reader) {
        return false;
      }

      return true;
    }
  };
};

exports.packetStreamBitReader = packetStreamBitReader;

var streamReader = function streamReader(packets) {
  return packetStreamBitReader(packetStreamGenerator(packetGenerator(packets)));
};

exports.streamReader = streamReader;

var elementaryStreamIterator = function elementaryStreamIterator(es, delimiter, includeDelimiter) {
  var reader = constructBitReader(es);
  var isFirst = true;

  if (delimiter === undefined) {
    delimiter = [0, 0, 0, 1];
  }

  if (includeDelimiter === undefined) {
    includeDelimiter = false;
  }

  return {
    next: function next() {
      var parse = true;
      var result = [];

      while (parse) {
        if (reader.atEnd()) {
          // If we're at the last result and need to prepend the delimiter
          if (result.length > 0) {
            if (includeDelimiter) {
              var _result;

              (_result = result).unshift.apply(_result, _toConsumableArray(delimiter));
            }
          }

          parse = false;
          break;
        }

        var byte = reader.readBits(8);

        if (byte !== undefined) {
          result.push(byte);
        }

        var check = result.slice(-delimiter.length);

        if (equal(check, delimiter)) {
          if (!isFirst) {
            if (includeDelimiter) {
              var _result2;

              (_result2 = result).unshift.apply(_result2, _toConsumableArray(check));

              result = result.slice(0, -delimiter.length);
            } else {
              result = result.slice(0, -delimiter.length);
            }

            parse = false;
            break;
          } else {
            isFirst = false;
            result = [];
          }
        }
      } /// Outside parse loop


      if (result.length > 0) {
        return result;
      }

      return undefined;
    },
    reader: reader
  };
};

exports.elementaryStreamIterator = elementaryStreamIterator;

var equal = function equal(bufA, bufB) {
  if (bufA.length != bufB.length) {
    return false;
  }

  for (var i = 0; i != bufA.length; i++) {
    if (bufA[i] != bufB[i]) {
      return false;
    }
  }

  return true;
};

exports.equal = equal;

var constructBitReader = function constructBitReader(stream) {
  var reader;

  if (stream[0].constructor.name === _types.default.Array) {
    reader = streamReader(stream);
  } else if (stream[0].objType === _types.default.MediaPacket) {
    reader = streamReader(stream);
  } else if (stream[0].objType === _types.default.PESPacket) {
    reader = streamReader(stream);
  } else {
    var buffer = new Uint8Array(stream);
    reader = new BitReader(buffer);
  }

  return reader;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/helpers/byte-helpers.js
// module id = 41
// module chunks = 0